import { destroy, post, put } from '@alltrails/shared/api';
import { IdKey } from '@alltrails/shared/types/lists';
import List from 'types/List';

export async function saveList(ids: any[]) {
  return post('/api/alltrails/lists/reorder', { ordered_list_ids: ids });
}

type DeleteListsResponse = {
  lists: List[];
};

export async function deleteList(id: IdKey) {
  return destroy<DeleteListsResponse>(`/api/alltrails/lists/${id}`);
}

type ReorderResponse = {
  listItems: any;
  profile_photo_url: string;
  success: boolean;
};

export async function saveListItems(listId: IdKey, itemIds: IdKey[], range?: number[]) {
  return put<ReorderResponse>(`/api/alltrails/v2/lists/${listId}/reorder`, { ordered_list_item_ids: itemIds, item_range: range });
}
